import { getApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  updateProfile,
  updatePassword,
  signInWithCustomToken,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
  signInWithRedirect,
} from "firebase/auth";

export const loginWithToken = async (token: string) => {
  const auth = getAuth(getApp());
  return await signInWithCustomToken(auth, token);
};

export const loginUserEmailPassword = async (user: any) => {
  const auth = getAuth(getApp());
  const { email, password } = user;
  const cred = await signInWithEmailAndPassword(auth, email, password);
  return cred;
};

export const registerUser = async (user: any) => {
  const auth = getAuth(getApp());
  const { email, password, name } = user;

  try {
    const cred = await createUserWithEmailAndPassword(auth, email, password);
    updateProfile(cred.user, {
      displayName: name,
    });
    return cred;
  } catch (error: any) {
    throw error;
  }
};

export const resetPassword = async (email: string) => {
  const auth = getAuth(getApp());
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (error: any) {
    throw error;
  }
};

export const changePassword = async (
  oldPassword: string,
  newPassword: string,
) => {
  const auth = getAuth(getApp());
  try {
    if (auth.currentUser?.email) {
      return signInWithEmailAndPassword(
        auth,
        auth.currentUser?.email,
        oldPassword,
      ).then(async () => {
        if (auth.currentUser) {
          await updatePassword(auth.currentUser, newPassword);
        }
      });
    }
  } catch (error: any) {
    throw error;
  }
};

export const loginWithGoogle = async () => {
  const auth = getAuth(getApp());
  const provider = new GoogleAuthProvider();

  provider.setCustomParameters({
    locale: navigator.language ?? "en",
  });

  try {
    return await signInWithPopup(auth, provider);
  } catch (error: any) {
    console.log("Popup auth failed:", error.code);
    if (error.code?.includes('auth/popup') || error.message?.includes('Cross-Origin-Opener-Policy')) {
      console.log("Falling back to redirect auth");
      return signInWithRedirect(auth, provider);
    }
    throw error;
  }
};

export const loginWithApple = async () => {
  const auth = getAuth(getApp());
  const provider = new OAuthProvider("apple.com");

  provider.setCustomParameters({
    locale: navigator.language ?? "en",
  });

  try {
    return await signInWithPopup(auth, provider);
  } catch (error: any) {
    console.log("Popup auth failed:", error.code);
    if (error.code?.includes('auth/popup') || error.message?.includes('Cross-Origin-Opener-Policy')) {
      console.log("Falling back to redirect auth");
      return signInWithRedirect(auth, provider);
    }
    throw error;
  }
};